export const renameFile = (originalFile: File, newName: string) =>
  new File([originalFile], newName, {
    type: originalFile.type,
    lastModified: originalFile.lastModified,
  });

export const getFileExt = (file: File) => file.name.split('.').at(-1);

export const truncFileExt = (file: File) => file.name.split('.').slice(0, -1).join('');
